/**
 * @ngdoc directives
 * @memberof mercury.modules.time
 * @name tabdraw
 */
angular.module('mercury.modules.time.roster')
.directive('tabdraw', ["Budgets", "$filter", "$q", "reporttime", "TimeRosteredShifts", "ReportSales", "userinfo", function(Budgets, $filter, $q, reporttime, TimeRosteredShifts, ReportSales, userinfo) {
  return {
    restrict: 'A',
    templateUrl: 'modules/time/roster/tabdraw.tpl.html',
    scope: true,
    link: function(scope) {
      scope.currentTab = null;
      
      reporttime.setFormatString('h:mma ddd do');
      scope.reportType = reporttime.reportType();

      var salesTrend = [];

      scope.reportsPermission = userinfo.companyHasPermission('Report');
      scope.payrollPermission = userinfo.companyHasPermission('Payroll');

      scope.graphSalesTrend = 'last';
      scope.graphSalesTrendOptions = {
        last: 'Last Week',
        average: '4 Week Average',
        predict: 'Predict'
      };

      scope.graphOptions = {
        chartArea: {top: 5, left: 0, height: '95%', width: '100%'},
        pointSize: 0,
        animation: {duration: 500},
        bar: {groupWidth: '90%'},
        vAxes: {
          0: {
            gridlines: {
              count: 0
            },
            baselineColor: '#FFFFFF',
            textPosition: 'none',
            viewWindow: {
              min: 0,
              max: 170
            },
            minValue: 0,
            viewWindowMode: 'explicit'
          }, // bars
          1: {
            gridlines: {
              count: 0
            },
            baselineColor: '#FFFFFF',
            textPosition: 'none',
            viewWindow: {
              min: 0,
              max: 560
            },
            minValue: 0,
            viewWindowMode: 'explicit'
          } // line
        },
        hAxis: {
          gridlines: {
            count: 0
          },
          baselineColor: '#FFFFFF',
          textPosition: 'none'
        },
        curveType: 'function',
        legend: {position: 'none'},
        tooltip: {textStyle: {fontSize: 11}},
        focusTarget: 'category'
      };

      if (scope.reportsPermission && scope.payrollPermission) {
        scope.graphCols = [
          {label: 'Day', type: 'string', key: 'startTime', filter: 'reporttimeformat'},
          {label: 'Sales Trend', type: 'number', key: 'invoices', filter: 'currency'},
          {label: 'Wage Cost', type: 'number', key: 'wageCost', filter: 'currency'}
        ];
        scope.graphOptions.series = [
          {
            targetAxisIndex: 1,
            type: 'line',
            color: '#9645dd'
          },
          {
            targetAxisIndex: 0,
            type: 'bars',
            color: '#BAD3A2'
          }
        ];
      } else if (scope.payrollPermission) {
        scope.graphCols = [
          {label: 'Day', type: 'string', key: 'startTime', filter: 'reporttimeformat'},
          {label: 'Wage Cost', type: 'number', key: 'wageCost', filter: 'currency'}
        ];
        scope.graphOptions.series = [
          {
            targetAxisIndex: 0,
            type: 'bars',
            color: '#BAD3A2'
          }
        ];
      } else {
        scope.graphCols = [
          {label: 'Day', type: 'string', key: 'startTime', filter: 'reporttimeformat'},
          {label: 'Hours', type: 'number', key: 'hours'}
        ];
        scope.graphOptions.series = [
          {
            targetAxisIndex: 0,
            type: 'line',
            color: '#9645dd'
          }
        ];
      }

      // perform evaluation of how shifts conincide with our analysis increment values.
      var effectiveTime = function(shift, startTime, endTime) {
        var hours = 0;
        var escrowHours = 0;
        var unpaidBreakHours = 0;
        // for example, if we are doing a day view analysis, then the increment value that we will use would be 2 hours diffs.
        // therefore clocking is checked to see if it falls before the evaluation period end, and if the clockout falls after the evaluation period start
        if (moment(shift.clockinTime).isBefore(endTime) && moment(shift.clockoutTime).isAfter(startTime)) {
          effectiveStart = moment.max(moment(shift.clockinTime), moment(startTime));
          effectiveEnd = moment.min(moment(shift.clockoutTime), moment(endTime));

          // depending on how much of the period the clockins occupy, we calculate the diff using min/max and relay it as the total hours worked for that period.
          // basically, this is also where we have to iterate through all the breaks to see if the breaks falls in those diffs as well and if it does
          // for all unpaid breaks, remove them from the total hours.
          angular.forEach(shift.breaks, function(breakObj) {
            if (!breakObj.paid) {
              if (moment(breakObj.breakStart).isBefore(endTime) && moment(breakObj.breakEnd).isAfter(startTime)) {
                effectiveBreakStart = moment.max(moment(breakObj.breakStart), moment(startTime));
                effectiveBreakEnd = moment.min(moment(breakObj.breakEnd), moment(endTime));

                if (effectiveBreakEnd.isAfter(effectiveBreakStart)) {
                  unpaidBreakHours += effectiveBreakEnd.diff(effectiveBreakStart, 'minutes') / 60;
                }
              }
            }
          });

          escrowHours = (effectiveEnd.diff(effectiveStart, 'minutes') / 60);
          hours = (escrowHours >= unpaidBreakHours) ? (escrowHours - unpaidBreakHours) : escrowHours;

        }

        return hours;
      };

      // bascially this function gets data to understand exactly what view is active, an hour or a day.
      // If it is an hour, then 2 is sent as an increment value. Basically to show data per 2 hours.
      var periodTotals = function(incrementAmount, incrementUnit) {
        var startTime = scope.viewStartDateTime;
        var endTime = scope.viewEndDateTime;
        var totals = [];

        for (var iterator = moment(startTime); iterator.isBefore(endTime); iterator.add(incrementAmount, incrementUnit)) {
          totals.push({
            start: iterator.clone(),
            end: iterator.clone().add(incrementAmount, incrementUnit),
            pay: 0,
            hours: 0
          });
        }

        // for each period that needs to be evaluated, compare each roster against it so that for that period we can have a cummulative breakdown.
        angular.forEach(totals, function(period) {
          angular.forEach(scope.rosteredShifts, function(rosteredShift) {
            if (scope.isRoleShown(rosteredShift.roleId)) {
              var shiftEffectiveHours = effectiveTime(rosteredShift, period.start, period.end);
              period.hours += shiftEffectiveHours;
              period.pay += shiftEffectiveHours * rosteredShift.adjustedHourlyRate;
            }
          });
        });
        return totals;
      };

      var refreshData = function() {
        var analyseTotals;
        if (scope.reportType == 'day') {
          analyseTotals = periodTotals(2, 'hour');
        } else {
          analyseTotals = periodTotals(1, 'day');
        }

        scope.analyseHours = [];
        angular.forEach(analyseTotals, function(total) {
          scope.analyseHours.push(total.hours);
        });

        if (scope.payrollPermission) {
          scope.analyseCost = [];
          angular.forEach(analyseTotals, function(total) {
            scope.analyseCost.push(total.pay);
          });

          if (scope.reportType == 'week' && scope.reportsPermission) {
            var mappedBudgets = {};
            angular.forEach(scope.budgets, function(budget) {
              mappedBudgets[moment(budget.date).mStartOf('day').format()] = budget.amount / (budget.salesTax + 1);
            });

            scope.analyseBudget = [];
            scope.analyseRatio = [];
            angular.forEach(analyseTotals, function(period) {
              var budget = mappedBudgets[period.start.format()] || 0;
              var ratio = (budget) ? (period.pay / budget) * 100 : 0;

              scope.analyseBudget.push(budget);
              scope.analyseRatio.push(ratio);
            });
          }
        }

        var visualizeIncrement = (scope.reportType == 'day') ? 0.5 : 1;
        var visualizeTotals = periodTotals(visualizeIncrement, 'hour');

        var graphRows = [];
        var maxWageCost = 0;
        var maxHours = 0;
        var maxSales = 0;

        angular.forEach(visualizeTotals, function(total, index) {
          graphRows.push({
            startTime: total.start.format(),
            invoices: salesTrend[index],
            wageCost: total.pay,
            hours: total.hours
          });
          maxWageCost = Math.max(maxWageCost, total.pay);
          maxHours = Math.max(maxWageCost, total.hours);
          maxSales = Math.max(maxSales, salesTrend[index]);
        });
        scope.graphData = graphRows;

        // Set the bounds of the chart's y axis to fit the data, add a little bit so the tops of the
        // sales curve don't go over the edge
        if (scope.payrollPermission) {
          scope.graphOptions.vAxes[0].viewWindow.max = maxWageCost + maxWageCost * 0.1;
        } else {
          scope.graphOptions.vAxes[0].viewWindow.max = maxHours + maxHours * 0.1;
        }
        scope.graphOptions.vAxes[1].viewWindow.max = maxSales + maxSales * 0.05;
      };

      var getLatestSalesTrend = function(start, end, interval) {
        ReportSales.getByInterval(start, end, interval)
        .then(function(results) {
          angular.forEach(results, function(period) {
            salesTrend.push(period.invoices);
          });

          scope.salesLoading = false;
          refreshData();
        });
      };

      var getAverageSalesTrend = function(start, end, interval) {
        $q.all({
          baseWeek: ReportSales.getByInterval(start, end, interval),
          weekOne: ReportSales.getByInterval(moment(start).subtract(1, 'week').format(), moment(end).subtract(1, 'week').format(), interval),
          weekTwo: ReportSales.getByInterval(moment(start).subtract(2, 'week').format(), moment(end).subtract(2, 'week').format(), interval),
          weekThree: ReportSales.getByInterval(moment(start).subtract(3, 'week').format(), moment(end).subtract(3, 'week').format(), interval)
        })
        .then(function(results) {
          angular.forEach(results.baseWeek, function(period, index) {
            var avgInvoice = (period.invoices + results.weekOne[index].invoices + results.weekTwo[index].invoices + results.weekThree[index].invoices) / 4;
            salesTrend.push(avgInvoice);
          });

          scope.salesLoading = false;
          refreshData();
        });
      };

      var getPredictedSalesTrend = function(start, end, interval) {
        $q.all({
          baseWeek: ReportSales.getByInterval(start, end, interval),
          weekOne: ReportSales.getByInterval(moment(start).subtract(1, 'week').format(), moment(end).subtract(1, 'week').format(), interval),
          weekTwo: ReportSales.getByInterval(moment(start).subtract(2, 'week').format(), moment(end).subtract(2, 'week').format(), interval),
          weekThree: ReportSales.getByInterval(moment(start).subtract(3, 'week').format(), moment(end).subtract(3, 'week').format(), interval),
          budgets: Budgets.getAll(moment(start).subtract(3, 'week').format(), scope.viewEndDateTime)
        })
        .then(function(results) {
          var budgetMap = {};
          angular.forEach(results.budgets, function(budget) {
            budgetMap[moment(budget.date).mStartOf('day').format()] = budget.amount;
          });

          angular.forEach(results.baseWeek, function(period, index) {
            var periodTotals = [];
            var baseBudget = budgetMap[moment(period.startTime).mStartOf('day').format()];
            if (baseBudget) {
              periodTotals.push(period.invoices / baseBudget);
            }

            var weekOneBudget = budgetMap[moment(results.weekOne[index].startTime).mStartOf('day').format()];
            if (weekOneBudget) {
              periodTotals.push(results.weekOne[index].invoices / weekOneBudget);
            }

            var weekTwoBudget = budgetMap[moment(results.weekTwo[index].startTime).mStartOf('day').format()];
            if (weekTwoBudget) {
              periodTotals.push(results.weekTwo[index].invoices / weekTwoBudget);
            }

            var weekThreeBudget = budgetMap[moment(results.weekThree[index].startTime).mStartOf('day').format()];
            if (weekThreeBudget) {
              periodTotals.push(results.weekThree[index].invoices / weekThreeBudget);
            }

            var budget = budgetMap[moment(period.startTime).mStartOf('day').add(1, 'week').format()];
            var predictedInvoices = 0;
            if (budget && periodTotals.length > 0) {
              angular.forEach(periodTotals, function(total) {
                predictedInvoices += total * budget;
              });
              predictedInvoices = predictedInvoices / periodTotals.length;
            }
            salesTrend.push(predictedInvoices);
          });

          scope.salesLoading = false;
          refreshData();
        });
      };

      var getSalesTrend = function() {
        if (!scope.reportsPermission || !scope.payrollPermission) {
          return;
        }

        salesTrend = [];

        var start = moment(scope.viewStartDateTime).subtract(1, 'week').format();
        var end = moment(scope.viewEndDateTime).subtract(1, 'week').format();

        var interval = (reporttime.reportType() == 'week') ? '01:00:00' : '00:30:00';

        switch (scope.graphSalesTrend) {
          case 'last':
            getLatestSalesTrend(start, end, interval);
          break;
          case 'average':
            getAverageSalesTrend(start, end, interval);
          break;
          case 'predict':
            getPredictedSalesTrend(start, end, interval);
          break;
        }
      };

      getSalesTrend();

      scope.changeGraphSalesTrend = function(selected) {
        scope.graphSalesTrend = selected;

        getSalesTrend();
      };

      scope.tabClick = function(tabType) {
        var duration = 200;

        if (scope.currentTab === null) {
          $('.tab-content').css({'border': '1px solid #CCC'});
          $('.tab-content').show('blind', {direction: 'down'}, duration);
          $('.tab-container > .nav-tabs').animate({'top': scope.isTemplate ? '-96px' : '-181px'}, duration);
          scope.currentTab = tabType;
        } else if (tabType == 'close') {
          $('.tab-content').css({'border': 'none'});
          $('.tab-content').hide('blind', {direction: 'down'}, duration);
          $('.tab-container > .nav-tabs').animate({'top': '-25px'}, duration);

          scope.currentTab = null;
        } else {
          scope.currentTab = tabType;
        }
      };

      // Inital load
      refreshData();

      // When a shift is updated.
      scope.$on('totalsChanged', refreshData);
    }
  };
}]);
